import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import React from 'react';
import { permissionTypes } from './index';
import OrganizationDemandList from '../components/OrganizationDemandList';
import InstructorDemandList from '../components/InstructorDemandList';
import {
  COURSE_LIST_PATH,
  COURSE_RUN_DEMANDS_DETAIL_PATH,
  COURSE_RUN_DEMANDS_PATH,
  CREATE_COURSE_PATH,
  DASHBOARD_PATH,
  INSTRUCTOR_FORM_EDIT_PATH,
  INSTRUCTOR_FORM_NEW_PATH,
  INSTRUCTOR_SINGLE_PATH,
  MY_COURSE_RUN_DEMANDS_PATH,
  ORG_COURSE_PATH,
  ORG_FORM_PATH,
  ORG_SINGLE_PATH,
  UPDATE_COURSE_PATH,
} from './AllRoutes';
import Toast from '../components/Toast';
import store from '../app/store/store';
import { useHistory, useLocation } from 'react-router-dom';
import { ACCEPT, DENY, PENDING } from './CourseDemandStatus';

export function getDashboardListOptions(role, listOfOrganizationDemands, listOfInstructorDemands) {
  return (
    <Row>
      <Col xs={12} className={'my-4'}>
        {true && listOfOrganizationDemands.data && !listOfOrganizationDemands.loading && (
          <OrganizationDemandList
            title={'درخواست های ساخت سازمان'}
            organizationDemandsList={listOfOrganizationDemands}
            count={listOfOrganizationDemands.count}
          />
        )}
      </Col>
      <Col xs={12} className={'my-4'}>
        {true && listOfInstructorDemands.data && !listOfInstructorDemands.loading && (
          <InstructorDemandList
            title={'درخواست تبدیل به استاد'}
            instructorDemandsList={listOfInstructorDemands}
            count={listOfInstructorDemands.count}
          />
        )}
      </Col>
    </Row>
  );
}

function getInstructorButtonText(listOfInstructorDemands) {
  if (isUserInstructorInAnyOrg(listOfInstructorDemands)) {
    return 'پروفایل استادی من';
  } else {
    return 'تبدیل به استاد شوید';
  }
}

export function isUserInstructorInAnyOrg(listOfInstructorDemands) {
  let res = false;
  if (listOfInstructorDemands.data != null) {
    listOfInstructorDemands.data.forEach(item => {
      if (item.status === ACCEPT) {
        res = true;
      }
    });
  }
  return res;
}

export function isUserPendingInstructorInAnyOrg(listOfInstructorDemands) {
  let res = false;
  if (listOfInstructorDemands.data != null) {
    listOfInstructorDemands.data.forEach(item => {
      if (item.status === PENDING) {
        res = true;
      }
    });
  }
  return res;
}

export function isUserDenyInstructorInAnyOrg(listOfInstructorDemands) {
  let res = false;
  if (listOfInstructorDemands.data != null) {
    listOfInstructorDemands.data.forEach(item => {
      if (item.status === DENY) {
        res = true;
      }
    });
  }
  return res;
}

export function getDashboardCreateOptions(
  selectedOrg,
  role,
  createCourse,
  createOrg,
  homeInstructorButtonClick,
  allOrgs,
  listOfInstructorDemands
) {
  return (
    <Row className={'justify-content-center'}>
      {role?.name !== permissionTypes.admin && !isNewUser(allOrgs) && (
        <Col xl={3}>
          <Link className="green-btn-welcome" onClick={createCourse}>
            میخواهم دوره ایجاد کنم
          </Link>
        </Col>
      )}
      {true && (
        <Col xl={3}>
          <Link className="blue-btn-welcome" onClick={createOrg}>
            میخواهم سازمان ایجاد کنم
          </Link>
        </Col>
      )}
      {true && (
        <Col xl={3}>
          <Link className="orange-btn-welcome" onClick={homeInstructorButtonClick}>
            {getInstructorButtonText(listOfInstructorDemands)}
          </Link>
        </Col>
      )}
    </Row>
  );
}

let getMenuObj = (title, desc, root, page) => ({ title, desc, root, page });

export function getVisibleMenuItems(allPermission, selectedRole) {
  let homeObj = getMenuObj('داشبورد', 'home', true, '');
  let meObj = getMenuObj('صفحه من', 'my page', true, 'me');
  let orgsManagement = getMenuObj('مدیریت سازمان', 'orgs management', true, 'orgs');
  let coursesManagement = getMenuObj('مدیریت دوره ها', 'courses management', true, 'courses');
  let myCreateCourseDemands = getMenuObj(
    'دوره های من',
    'my course run demands management',
    true,
    'my-course-run-demands'
  );

  let all = [];

  if (isNewUser(allPermission)) {
    all.push(homeObj);
  } else {
    switch (selectedRole?.name) {
      case permissionTypes.owner: {
        all.push(homeObj);
        all.push(orgsManagement);
        all.push(coursesManagement);
        break;
      }
      case permissionTypes.admin: {
        all.push(homeObj);
        all.push(orgsManagement);
        break;
      }
      case permissionTypes.cc: {
        all.push(homeObj);
        all.push(coursesManagement);
        break;
      }
      case permissionTypes.instructor: {
        all.push(homeObj);
        all.push(coursesManagement);
        break;
      }
      default:
        all.push(homeObj);
        break;
    }
  }

  return all;
}

function isNewUser(allPermission) {
  return allPermission !== null && allPermission.length === 0;
}

export function canAccessThisRoute(role, path) {
  switch (path) {
    case DASHBOARD_PATH:
      return true;
    case COURSE_RUN_DEMANDS_PATH:
      return isOwner(role) || isCourseCreate(role) || isInstructor(role) || isAdmin(role);
    case COURSE_RUN_DEMANDS_DETAIL_PATH:
      return true;
    case MY_COURSE_RUN_DEMANDS_PATH:
      return true;
    case COURSE_LIST_PATH:
      return (
        role?.name === permissionTypes.owner ||
        role?.name === permissionTypes.cc ||
        role?.name === permissionTypes.instructor
      );
    case CREATE_COURSE_PATH:
      return role?.name !== permissionTypes.admin;
    case UPDATE_COURSE_PATH:
      return true;
    case ORG_COURSE_PATH:
      return true;
    case ORG_SINGLE_PATH:
      return role?.name === permissionTypes.admin || role?.name === permissionTypes.owner;
    case ORG_FORM_PATH:
      return true;
    case INSTRUCTOR_FORM_NEW_PATH:
      return true;
    case INSTRUCTOR_FORM_EDIT_PATH:
      return true;
    case INSTRUCTOR_SINGLE_PATH:
      return true;

    default:
      return false;
  }
}

function isOwner(role) {
  return role?.name === permissionTypes.owner;
}

function isAdmin(role) {
  return role?.name === permissionTypes.admin;
}

function isCourseCreate(role) {
  return role?.name === permissionTypes.cc;
}

function isInstructor(role) {
  return role?.name === permissionTypes.instructor;
}

export function getCourseCreateButton(role) {
  if (role?.name !== permissionTypes.instructor) {
    return (
      <div className={'d-flex justify-content-end'}>
        <Link to={'/courses/new'}>
          <Button>
            <i className="fas fa-plus" />
            ایجاد دوره
          </Button>
        </Link>
      </div>
    );
  }
}

export function getCourseCreateActionButton(role, handleCancelClick, type) {
  if (role?.name === permissionTypes.admin && type !== 'admin') {
    return (
      <Button variant={'outline-danger'} onClick={() => handleCancelClick(true)}>
        <i className="fas fa-times" />
        لغو درخواست
      </Button>
    );
  }
  if (role?.name === permissionTypes.owner) {
    return (
      <Button variant={'outline-danger'} onClick={() => handleCancelClick(true)}>
        <i className="fas fa-times" />
        لغو درخواست
      </Button>
    );
  }
}

export function getAddUserInOrgOptions(role) {
  if (role?.name === permissionTypes.admin) {
    return [{ label: 'دوره ساز', value: 'course-creator' }];
  } else {
    return [
      { label: 'دوره ساز', value: 'course-creator' },
      { label: 'مدیر', value: 'admin' },
    ];
  }
}
